import ComponentHeader from "../CommonComponents/componentHeader";
import React, { useState } from "react";
import ExtendedReportsWrapper from "./extendedReportWrapper";
import RightChevron from "../Icons/right-chevron";
import "../../Stylesheets/reports.css"
import InfinityIcon from "../Icons/infinity-icon";
import Upchart from "../Icons/upchart";
import AnalyticsWrapper from "../Analytics/analyticsWrapper";
import ChAnalyticsWrapper from "../ChAnalytics/ChAnalyticsWrapper";
import MapIcon from "../Icons/map-icon";
import HeatmapWrapper from "../Heatmap/HeatmapWrapper";
import ChHeatmapWrapper from "../ChHeatmap/ChHeatmapWrapper";
import BarChartIcon from "../Icons/bar-chart-icon";
import PerformanceReportWrapper from "../PerformanceReport/performanceReportWrapper";
import ChPerformanceReportWrapper from "../ChPerformanceReport/ChPerformanceReportWrapper";
import { USE_CLICKHOUSE_ANALYTICS } from "../../configs";
export const REPORTS_COMPONENT = "REPORTS_COMPONENT";

const ReportsWrapper = () => {
  const isChEnterprise = USE_CLICKHOUSE_ANALYTICS;

  const reports = [
    {
      icon: <InfinityIcon />,
      header: "Extended",
      description: "Comprehensive overview providing detailed insights into all order-related metrics.",
      component: ExtendedReportsWrapper,
    },
    {
      icon: <Upchart />,
      header: "Analytics",
      description: "Time-based performance with charts for comprehensive insights into trends.",
      component: isChEnterprise ? ChAnalyticsWrapper : AnalyticsWrapper,
    },
    {
      icon: <MapIcon />,
      header: "Heatmap",
      description: "Spatial order distribution on a map for quick trend visualization.",
      component: isChEnterprise ? ChHeatmapWrapper : HeatmapWrapper,
    },
    {
      icon: <BarChartIcon />,
      header: "Performance",
      description: "On-time delivery metrics with pickup, delivery, and drive time distributions.",
      component: isChEnterprise ? ChPerformanceReportWrapper : PerformanceReportWrapper,
    }
  ];

  const [selectedReport, setSelectedReport] = useState(null);

  const reportHeader = (<div className="report-page-header">
    <div className="reports-button" onClick={() => setSelectedReport(null)}>Reports</div>
    <RightChevron />
    <div>{selectedReport?.header}</div>
  </div>);

  const Component = selectedReport === null ? 
  () => <div className="report-card-container">
    {reports.map((r, i) => <div className="card" onClick={() => setSelectedReport(r)} key={i}>
      <div className="card-icon">{r.icon}</div>
      <div className="card-title">{r.header}</div>
      <div className="card-details">{r.description}</div>
    </div>)}
  </div> : 
  selectedReport.component;

  return (
      <>
        <ComponentHeader title={selectedReport === null ? "Reports": reportHeader} />
        <Component/>
      </>
  )
};

export default ReportsWrapper;
